import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué es la depresión resistente al tratamiento?",
    answer:
      "La depresión resistente al tratamiento es el trastorno depresivo mayor que no ha mejorado lo suficiente tras probar dos o más antidepresivos con la dosis y duración adecuadas.",
  },
  {
    question: "¿SAINT® es para la depresión resistente al tratamiento?",
    answer:
      "Sí. SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos, lo que incluye la depresión resistente al tratamiento.",
  },
];

export const esWhatIsTrd = makeEsArticle({
  slug: "what-is-treatment-resistant-depression",
  title: "¿Qué es la depresión resistente al tratamiento?",
  description:
    "La depresión resistente al tratamiento es el trastorno depresivo mayor que no mejora tras dos o más antidepresivos. SAINT® está autorizado por la FDA para adultos en esta situación.",
  h1: "¿Qué es la depresión resistente al tratamiento?",
  breadcrumbLabel: "¿Qué es la depresión resistente?",
  shortAnswer:
    "La depresión resistente al tratamiento es el trastorno depresivo mayor que no ha mejorado lo suficiente tras probar dos o más antidepresivos con la dosis y duración adecuadas. SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos, lo que incluye la depresión resistente al tratamiento.",
  keyTakeaways: [
    "La depresión resistente no mejora tras dos o más antidepresivos.",
    "SAINT® está autorizado por la FDA para adultos en esta situación.",
    "La TMS convencional también es una opción para el trastorno depresivo mayor.",
    "Spravato está autorizado para la depresión resistente al tratamiento.",
    "La idoneidad se confirma mediante una evaluación psiquiátrica.",
  ],
  sections: [
    {
      heading: "Definición",
      paragraphs: [
        "La depresión resistente al tratamiento se define como el trastorno depresivo mayor que no ha mejorado lo suficiente tras probar dos o más antidepresivos con la dosis y duración adecuadas.",
      ],
    },
    {
      heading: "Opciones de tratamiento",
      paragraphs: [
        "SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. La TMS convencional también es una opción, ampliamente cubierta por los seguros. Spravato (esketamina) está autorizado por la FDA para la depresión resistente al tratamiento.",
      ],
    },
    {
      heading: "Cómo empezar",
      paragraphs: [
        "Si cree que puede tener depresión resistente al tratamiento, una evaluación psiquiátrica puede ayudarle a identificar las opciones. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
